import React from 'react'
import { gsap, Power2, ScrollTrigger } from 'gsap/all'

gsap.registerPlugin(ScrollTrigger)

class InfoPanel extends React.Component {
    constructor(props) {
        super(props)

        this.domRef = React.createRef()
    }

    componentDidMount() {
        document.addEventListener('allimagesloaded', () => {
            gsap.timeline({
                ease: Power2.easeOut,
                scrollTrigger: {
                    trigger: this.domRef.current,
                    toggleActions: 'restart',
                    start: 'top bottom',
                    end: 'top 60%',
                    scrub: true
                }
            })
                .from(this.domRef.current, {
                    opacity: 0
                }, '-=0.25')
                .from(this.domRef.current.querySelector('.icon'), {
                    y: 50,
                    opacity: 0
                })
                .from(this.domRef.current.querySelector('.text'), {
                    y: 50,
                    opacity: 0
                }, '-=0.25')
        })
    }

    render() {
        const { sideImageRef, children } = this.props

        return (
            <div className="info-panel" ref={this.domRef}>
                <div className="content">
                    <div className="icon">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50px" height="50px" viewBox="0 0 22 22" >
                            <g>
                                <path className="st0" d="M11,2.2c4.8,0,8.8,3.9,8.8,8.8s-3.9,8.8-8.8,8.8S2.2,15.8,2.2,11S6.2,2.2,11,2.2 M11,0C4.9,0,0,4.9,0,11
                                    s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0L11,0z"/>
                            </g>
                            <g>
                                <line className="st1" x1="11" y1="7.2" x2="11" y2="18.3" />
                            </g>
                            <g>
                                <line className="st1" x1="11" y1="3.2" x2="11" y2="5.5" />
                            </g>
                        </svg>
                    </div>

                    <div className="text">
                        {children}
                    </div>
                </div>
                {sideImageRef && <img src={sideImageRef} />}
            </div>
        )
    }
}

export default InfoPanel